// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text--heading-xl {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  font-size: 2rem;
  line-height: 1.375;
  letter-spacing: -0.0056em;
  font-weight: 700;
}
@media (min-width: 37.5em) {
  .text--heading-xl {
    font-size: 3.125rem;
    line-height: 1.32;
    letter-spacing: -0.0087em;
  }
}
.text--heading-l {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  font-size: 1.5rem;
  line-height: 1.45;
  letter-spacing: -0.0042em;
  font-weight: 700;
}
@media (min-width: 37.5em) {
  .text--heading-l {
    font-size: 2.25rem;
    line-height: 1.333;
    letter-spacing: -0.0063em;
  }
}
.text--heading-m {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  font-size: 1.125rem;
  line-height: 1.444;
  font-weight: 700;
}
@media (min-width: 37.5em) {
  .text--heading-m {
    font-size: 1.5rem;
    line-height: 1.45;
    letter-spacing: -0.0042em;
  }
}
.text--heading-s {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 700;
}
.text--heading-xs {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
  font-size: 0.875rem;
  line-height: 1.571;
  font-weight: 700;
}
.text--body-xl {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  font-size: 1.25rem;
  line-height: 1.6;
}
.text--body-l {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  font-size: 1rem;
  line-height: 1.625;
}
.text--body-m {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  font-size: 0.875rem;
  line-height: 1.571;
}
.text--body-s {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
  font-size: 0.75rem;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/text/dist/style.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;AACA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;EAC3B;AACF;AACA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;AACA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".text--heading-xl {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  font-size: 2rem;\n  line-height: 1.375;\n  letter-spacing: -0.0056em;\n  font-weight: 700;\n}\n@media (min-width: 37.5em) {\n  .text--heading-xl {\n    font-size: 3.125rem;\n    line-height: 1.32;\n    letter-spacing: -0.0087em;\n  }\n}\n.text--heading-l {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  font-size: 1.5rem;\n  line-height: 1.45;\n  letter-spacing: -0.0042em;\n  font-weight: 700;\n}\n@media (min-width: 37.5em) {\n  .text--heading-l {\n    font-size: 2.25rem;\n    line-height: 1.333;\n    letter-spacing: -0.0063em;\n  }\n}\n.text--heading-m {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  font-size: 1.125rem;\n  line-height: 1.444;\n  font-weight: 700;\n}\n@media (min-width: 37.5em) {\n  .text--heading-m {\n    font-size: 1.5rem;\n    line-height: 1.45;\n    letter-spacing: -0.0042em;\n  }\n}\n.text--heading-s {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  font-size: 1rem;\n  line-height: 1.5;\n  font-weight: 700;\n}\n.text--heading-xs {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n  font-size: 0.875rem;\n  line-height: 1.571;\n  font-weight: 700;\n}\n.text--body-xl {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  font-size: 1.25rem;\n  line-height: 1.6;\n}\n.text--body-l {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  font-size: 1rem;\n  line-height: 1.625;\n}\n.text--body-m {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  font-size: 0.875rem;\n  line-height: 1.571;\n}\n.text--body-s {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n  font-size: 0.75rem;\n  line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
